import { Grid, Divider } from "@mui/material";
import React from "react";

import AddEditVatBaseRow from "./AddEditVatBaseRow/AddEditVatBaseRow";
import {
  Container,
  HeaderName,
  ActionsBlock,
  RowContainer,
  MainContainer,
  AddRowContainer,
  CellBlock,
  CellSimpleText,
  AmountBlock,
  AmountContainer,
  AmountSpan,
  AmountCurrency,
} from "./styles";
import { ClientInvoiceVATBaseRef } from "../../../../../models/legal-entity-clients/client-invoices";
import { TransactionDTO } from "../../../../../models/transactions";

import ConfirmationRemoveItemDialog from "../../ConfirmationRemoveItemDialog/ConfirmationRemoveItemDialog";

interface Props {
  transaction: TransactionDTO;
  readOnly?: boolean;
  handleChange?: (field: keyof TransactionDTO, value: TransactionDTO[keyof TransactionDTO]) => void;
}

const VatCountries = ({ transaction: { clientInvoice }, readOnly = false, handleChange }: Props) => {
  const handleChangeVat = (value: ClientInvoiceVATBaseRef, idx: number): void => {
    if (clientInvoice) {
      idx < 0
        ? handleChange &&
          handleChange("clientInvoice", {
            ...clientInvoice,
            vatBases: [...(clientInvoice?.vatBases ?? []), value],
          })
        : handleChange &&
          handleChange("clientInvoice", {
            ...clientInvoice,
            vatBases: [
              ...(clientInvoice && clientInvoice.vatBases ? clientInvoice.vatBases.slice(0, idx) : []),
              value,
              ...(clientInvoice && clientInvoice.vatBases ? clientInvoice.vatBases.slice(idx + 1) : []),
            ],
          });
    }
  };

  const handleRemoveVat = (idx: number): void => {
    if (clientInvoice)
      handleChange &&
        handleChange("clientInvoice", {
          ...clientInvoice,
          vatBases: [
            ...(clientInvoice?.vatBases ?? []).slice(0, idx),
            ...(clientInvoice?.vatBases ?? []).slice(idx + 1),
          ],
        });
  };

  return (
    <Grid>
      {clientInvoice?.vatCountry && (
        <MainContainer>
          <div>
            <Container>
              <CellBlock>
                <HeaderName>VAT Country</HeaderName>
              </CellBlock>
              <CellBlock>
                <AmountBlock>
                  <HeaderName>Base</HeaderName>
                </AmountBlock>
              </CellBlock>
              <CellBlock>
                <HeaderName>VAT type %</HeaderName>
              </CellBlock>
              <CellBlock>
                <AmountBlock>
                  <HeaderName>VAT amount</HeaderName>
                </AmountBlock>
              </CellBlock>
              {!readOnly && (
                <ActionsBlock>
                  <HeaderName>Actions</HeaderName>
                </ActionsBlock>
              )}
            </Container>

            <Divider sx={{ width: readOnly ? "600px" : "700px" }} />

            {clientInvoice?.vatBases?.map((vat, idx) => {
              return (
                <RowContainer key={idx}>
                  <CellBlock>
                    <CellSimpleText>{clientInvoice?.vatCountry?.code}</CellSimpleText>
                  </CellBlock>
                  <CellBlock>
                    <AmountContainer>
                      <AmountSpan title={`${(+vat?.base).toLocaleCustom()}`}>
                        {(+vat?.base).toLocaleCustom()}
                      </AmountSpan>
                      <AmountCurrency>{clientInvoice?.currency?.code}</AmountCurrency>
                    </AmountContainer>
                  </CellBlock>
                  <CellBlock>
                    <CellSimpleText>{vat?.rate}%</CellSimpleText>
                  </CellBlock>
                  <CellBlock>
                    <AmountContainer>
                      <AmountSpan title={`${(+vat?.amount).toLocaleCustom()}`}>
                        {(+vat?.amount).toLocaleCustom()}
                      </AmountSpan>
                      <AmountCurrency>{clientInvoice?.currency?.code}</AmountCurrency>
                    </AmountContainer>
                  </CellBlock>
                  {!readOnly && (
                    <ActionsBlock>
                      <AddEditVatBaseRow
                        handleChangeVat={(value) => handleChangeVat(value, idx)}
                        vat={vat}
                        clientInvoice={clientInvoice}
                      />
                      <ConfirmationRemoveItemDialog
                        index={idx}
                        handleRemove={handleRemoveVat}
                      />
                    </ActionsBlock>
                  )}
                </RowContainer>
              );
            })}
          </div>

          {!readOnly && (
            <>
              <Divider sx={{ width: "700px" }} />

              <AddRowContainer>
                <AddEditVatBaseRow
                  handleChangeVat={(value) => handleChangeVat(value, -1)}
                  clientInvoice={clientInvoice}
                />
              </AddRowContainer>
            </>
          )}
        </MainContainer>
      )}
    </Grid>
  );
};

export default VatCountries;
